module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('div', {
    staticClass: "navs"
  }, [_c('router-link', {
    staticClass: "nav",
    class: {
      active: _vm.navNum === 1
    },
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("总览")]), _c('router-link', {
    staticClass: "nav",
    class: {
      active: _vm.navNum === 5
    },
    attrs: {
      "to": "/statistic"
    }
  }, [_vm._v("统计")]), _c('router-link', {
    staticClass: "nav",
    class: {
      active: _vm.navNum === 3
    },
    attrs: {
      "to": "/application"
    }
  }, [_vm._v("应用管理")]), _c('a', {
    staticClass: "nav",
    attrs: {
      "href": "https://help.upyun.com/knowledge-base/sim-api/ ",
      "target": "_blank"
    }
  }, [_vm._v("接口文档")])], 1), _c('div', {
    staticClass: "side-navs"
  }, [_c('a', {
    staticClass: "console",
    attrs: {
      "href": "https://console.upyun.com",
      "target": "_blank"
    }
  }, [_vm._v("控制台首页")]), _c('a', {
    staticClass: "profile",
    on: {
      "mouseenter": _vm.mouseEnter,
      "mouseleave": _vm.mouseLeave
    }
  }, [_vm._v(_vm._s(_vm.username || _vm.accountInfo.username)), _c('i', {
    staticClass: "arrow-down el-icon-caret-bottom"
  }), _c('div', {
    staticClass: "logout",
    class: {
      show: _vm.showLogout, hide: !_vm.showLogout
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("退出登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.upyun.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95453a9e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/headers.vue
// module id = 1008
// module chunks = 1